export const Reports = [{
  label: 'Sales',
  value: 'sales'
}, {
  label: 'Evaluations',
  value: 'evaluations'
}, {
  label: 'Feedback',
  value: 'feedback'
}, {
  label: 'Cloud conversions',
  value: 'conversions'
}, {
  label: 'Cloud renewals',
  value: 'renewals'
}, {
  label: 'Cloud churn',
  value: 'churn'
}, {
  label: 'Transactions',
  value: 'transactions'
}, {
  label: 'Licenses',
  value: 'licenses'
}, {
  label: 'Feedback details',
  value: 'feedback-details'
}, {
  label: 'Date API',
  value: ''
}];
export const DateRange = [{
  label: 'Last 30 days',
  value: 'past30Days'
}, {
  label: 'Last 90 days',
  value: 'past90Days'
}, {
  label: 'This month to date',
  value: 'thisMonth'
}, {
  label: 'Last month',
  value: 'lastMonth'
}, {
  label: 'Year to date',
  value: 'thisYear'
}, {
  label: 'Last year',
  value: 'lastYear'
}, {
  label: 'All dates',
  value: undefined
}, {
  label: 'Custom',
  value: 'custom'
}];
export const SalesBy = [{
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Sale type',
  value: 'type'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const EvaluationsBy = [{
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const FeedbackBy = [{
  label: 'Reason',
  value: 'reason'
}, {
  label: 'Type',
  value: 'type'
}];